import * as React from 'react';
import {style} from 'typestyle';
import {px, rem} from 'csx';
import {colorSlate, colorWhite} from '../theme/color';

export default class InlineStrap extends React.Component<any, any> {
  render() {
    return (
      <div className={InlineStrap.styles.body}>
        {this.props.children}
      </div>
    )
  }

  static styles = {
    body: style({
      padding: px(16),
      fontSize: rem(0.875),
      fontWeight: 500,
      background: colorSlate.darken(0.075).toString(),
      color: colorWhite.toString()
    })
  }
}